import { render, staticRenderFns } from "./SkuPatternEditor.vue?vue&type=template&id=b14115e6&scoped=true&"
import script from "./SkuPatternEditor.vue?vue&type=script&lang=js&"
export * from "./SkuPatternEditor.vue?vue&type=script&lang=js&"
import style0 from "./SkuPatternEditor.vue?vue&type=style&index=0&id=b14115e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14115e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VChip,VChipGroup,VSubheader})
